import { Component } from 'react'
import { announceRoute } from '../../NonReact/common/RxJS/RouterState'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { createRouteURI } from '../Utilities/RoutingUtils'

export function Route(id: RouteID) {
    return (target: typeof Component): void => {
        announceRoute({
            path: `${createRouteURI(id)}`,
            id,
            element: target.prototype.render()
        })
    }
}
